import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { StatusCodes } from 'http-status-codes';

import GuestBillingService from 'services/GuestBillingService';
import { translate } from 'services/i18nService';
import validation from 'pages/User/RegistrationForm/validation.util';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import StyledTextField from 'components/StyledTextField/StyledTextField';
import { PARSED_PASSWORD_STRENGTH_INCREASED } from 'enum/profile';
import {
  MAX_USERNAME_LENGTH,
  MIN_USERNAME_LENGTH,
  MIN_PASSWORD_LENGTH,
  MAX_PASSWORD_LENGTH,
  SPECIAL_CHARS_PASSWORD,
} from 'enum/inputs';
import {
  oldValidationPassword,
  passwordErrorMsg,
} from 'utils/helpers';
import parseCatch from 'utils/parseCatch';

import styles from './GuestBillingModalForm.css';


const FIELD_NAMES = {
  username: 'username',
  password: 'password',
};

class GuestBillingModalForm extends PureComponent {
  static propTypes = {
    close: PropTypes.func.isRequired,
    userActions: PropTypes.object.isRequired,
  };

  state = {
    apiError: {
      studioName: null,
      username: null,
    },
    disableSubmit: true,
    errorMessageVisible: false,
    isLoading: false,
    password: {
      isValid: true,
      value: '',
    },
    username: {
      errorMessage: translate('cam4bucks.cam4bucks.validation.isRequired'),
      isValid: true,
      value: '',
    },
  };

  componentWillUnmount() {
    this.setState({ isLoading: false });
  }

  setFieldValue = (field, isValid, errorMessage, currentState, apiCall) => {
    let updatedField = {};
    let translatedErrorMessage = undefined;

    switch (errorMessage) {
      case 'profile.change.password.jsp.4':
        translatedErrorMessage = translate('help.help.password.error');
        break;

      case 'profile.profile.username.error.invalid':
        translatedErrorMessage = translate(errorMessage, {
          0: MIN_USERNAME_LENGTH,
          1: MAX_USERNAME_LENGTH,
        });
        break;

      case 'profile.profile.password.error.specialchar':
        translatedErrorMessage = translate(errorMessage, { 0: SPECIAL_CHARS_PASSWORD });
        break;

      default:
        translatedErrorMessage = translate(errorMessage);
    }

    if (!apiCall || this.state[field].value === currentState.value) {
      updatedField = Object.assign({}, currentState, {
        isValid,
        errorMessage: translatedErrorMessage,
      });

      const remainingField = field === FIELD_NAMES.username ? this.state.password : this.state.username;
      const remainingFieldIsValid = !!remainingField.value && remainingField.isValid;
      const updatedFieldIsValid = !!updatedField.value && updatedField.isValid;
      const canSubmit = remainingFieldIsValid && updatedFieldIsValid;

      this.setState({ [field]: updatedField, disableSubmit: !canSubmit });
    }
  };

  handleUpdateField = (field, value) => {
    const { state } = this;
    const property = {};

    property[field] = Object.assign({}, state[field], { value });

    this.setState(property);

    switch (field) {
      case FIELD_NAMES.username:
        validation[field](property[field], this.setFieldValue);
        break;

      case FIELD_NAMES.password:
        this.setState({ errorMessageVisible: true });
        validation[field](property[field], this.setFieldValue, state.username.value);
        break;

      default:
        validation[field](property[field], this.setFieldValue);
    }
  };

  handleOldPasswordErrorMsg = () => {
    const { password, username } = this.state;
    if (oldValidationPassword(password.value)) {
      if (password.value === username.value) {
        return translate('profile.change.password.jsp.1');
      }

      return translate('profile.profile.password.error.ok');

    }

    return translate('profile.change.password.jsp.4', {
      0: MIN_PASSWORD_LENGTH,
      1: MAX_PASSWORD_LENGTH,
    });

  };

  handleErrorMsgVisibility = () => {
    const { errorMessageVisible, password, username } = this.state;
    if (errorMessageVisible) {
      if (PARSED_PASSWORD_STRENGTH_INCREASED) {
        return passwordErrorMsg(translate, password.value, username.value);
      }

      return this.handleOldPasswordErrorMsg();
    }
    if (!password.isValid) {
      return translate('cam4bucks.cam4bucks.validation.isRequired');
    }

    return null;
  };

  submitForm = () => {
    const { username, password } = this.state;
    this.setState({ isLoading: true });
    GuestBillingService.register(username.value, password.value).then((res) => {
      if (res.status === StatusCodes.OK && res.data.status === 'SUCCESS') {
        this.props.userActions.getUserState();
        this.props.close();
      } else {
        parseCatch(res);
      }
    });
  };

  onChangeUsernameField = (event) => {
    this.handleUpdateField(FIELD_NAMES.username, event.target.value);
  };

  onChangePasswordField = (event) => {
    this.handleUpdateField(FIELD_NAMES.password, event.target.value);
  };

  render() {
    const { username, password, disableSubmit, isLoading } = this.state;

    return (
      <Fragment>
        <p className={styles.text}>{translate('strings.join.now.text')}</p>
        <div>
          <p className={styles.inputContainer}>
            <StyledTextField
              error={!username.isValid}
              helperText={username.errorMessage && !username.isValid ? username.errorMessage : ''}
              label={translate('homepage.v2.studio.enter.a.username')}
              name="username"
              type="text"
              value={username.value}
              onChange={this.onChangeUsernameField}
            />
          </p>
          <p className={styles.inputContainer}>
            <StyledTextField
              error={!password.isValid}
              helperText={this.handleErrorMsgVisibility()}
              label={translate('profile.profile.enter.password')}
              name="password"
              type="password"
              value={password.value}
              onChange={this.onChangePasswordField}
            />
          </p>
        </div>
        <LoadingButton
          colorVariant="orange"
          customContainerClass={styles.submitButton}
          disabled={disableSubmit}
          isLoading={isLoading}
          onClick={this.submitForm}
        >
          {translate('strings.join.now')}
        </LoadingButton>
      </Fragment>
    );
  }
}

export default GuestBillingModalForm;
